module.exports = __webpack_public_path__ + "static/media/waveform.fbb8e695.svg";